<!-- <div class="custombg fixed-top">
  <app-header #header></app-header>
  <nav *ngIf="isAdd" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page" style="cursor:pointer" (click)="goToHome()">Home</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item active" style="cursor:pointer" aria-current="page" (click)="goToProjectContent()">
        Project Content</li>
      <li class="breadcrumb-item active" aria-current="page">Add Project</li>
    </ol>
  </nav>
  <nav *ngIf="isEdit" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page" style="cursor:pointer" (click)="goToHome()">Home</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item active" style="cursor:pointer" aria-current="page"
        (click)="goToCaseStudies(extractedString)">{{extractedString}}</li>
      <li class="breadcrumb-item active" aria-current="page">Edit Project</li>
    </ol>
  </nav>
  <nav *ngIf="isView && !isApproved" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page" style="cursor:pointer" (click)="goToHome()">Home</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item active" style="cursor:pointer" aria-current="page" (click)="goToApproval()">Pending
        Approvals</li>
      <li class="breadcrumb-item active" aria-current="page">View Project</li>
    </ol>
  </nav>
  <nav *ngIf="isView &&isApproved" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page" style="cursor:pointer" (click)="goToHome()">Home</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item active" style="cursor:pointer" aria-current="page" (click)="goToProjectContent()">
        Project Content</li>
      <li class="breadcrumb-item active" aria-current="page">View Project</li>
    </ol>
  </nav>
</div> -->

<div *ngIf="formData">
  <div class="modal-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-5 mt-5 mb-4 ">
        <div class="card">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto ">{{title}}</div>
          </div>
          <form class="form " [formGroup]="formData">
            <!---row loop-->
            <div class="row p-3 m-0 border-bottom">
              <div class="col-12 p-0 mb-2">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Project Code </span></div>
                      <input type="email" #projectCode class="form-control" placeholder="Enter Project Code"
                        formControlName="ProjectCode">
                      <div *ngIf=" formData.get('ProjectCode').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('ProjectCode').errors?.duplicate">
                          Project Code already exists</mat-error>
                      </div>

                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Project Name *</span></div>
                      <input type="text" class="form-control" [placeholder]="isView ? '' : 'Enter Project Name'"
                        maxlength="40" (input)="getFilteredProjectValues($event.target.value)"
                        (focus)="getFilteredProjectValues('')" [matAutocomplete]="topic"
                        formControlName="ProjectName" />
                      <mat-autocomplete autoActiveFirstOption #topic="matAutocomplete">
                        <mat-option *ngFor="let topic of filteredValues" [value]="topic.projectName">
                          {{ topic.projectName }}
                        </mat-option>
                      </mat-autocomplete>
                      <div *ngIf="formData.get('ProjectName').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('ProjectName').errors?.required">
                          Project Name is Required
                        </mat-error>


                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Project Manager *</span></div>
                      <input type="text" class="form-control" (keyup)="Onchange()"
                        [placeholder]="isView ? '' : 'Enter Project Manager'" maxlength="40"
                        (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
                        [matAutocomplete]="partner" formControlName="ProjectManager">
                      <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
                        (optionSelected)='setCurrentEmployee($event.option.id)'>
                        <mat-option *ngFor="let partner of filteredValue" [id]="partner.employeeId"
                          [value]="partner.name">
                          {{partner.name}} ({{partner.employeeId}})
                        </mat-option>
                      </mat-autocomplete>
                      <div *ngIf="formData.get('ProjectManager').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('ProjectManager').errors?.required">
                          Project Manager is Required</mat-error>
                        <mat-error class="errorFont" *ngIf="isProjectManger">
                          Invalid Format</mat-error>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0 mb-2">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">

                      <div><span class="secondaryInfo">Client Name </span></div>
                      <input type="email" class="form-control" [placeholder]="isView ? '' : 'Enter Client'"
                        formControlName="Client">
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Geography *</span></div>
                      <input type="email" class="form-control" [placeholder]="isView ? '' : 'Enter Geography'"
                        formControlName="Geography">
                      <div *ngIf="formData.get('Geography').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('Geography').errors?.required">
                          Geography is Required</mat-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Region *</span></div>
                      <input type="email" class="form-control" [placeholder]="isView ? '' : 'Enter Region'"
                        formControlName="Region">
                      <div *ngIf="formData.get('Region').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('Region').errors?.required">
                          Region is Required</mat-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0 mb-2">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">

                      <div><span class="secondaryInfo">Vertical Name *</span></div>
                      <select class="form-control" formControlName="Vertical">
                        <option value="" selected disabled hidden>Select</option>
                        <option *ngFor="let vertical of verticalOptions" [value]="vertical">{{vertical}}</option>
                      </select>
                      <div *ngIf="formData.get('Vertical').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('Vertical').errors?.required">
                          Vertical Name is Required</mat-error>
                      </div>
                    </div>

                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Status</span></div>
                      <select class="form-control" formControlName="ProjectStatus">
                        <option *ngFor="let status of statuses" [value]="status">{{status}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-4">
                    <div><span class="secondaryInfo">Logo</span></div>
                    <div class="custom-file pr-2">
                      <input type="file" class="custom-file-input" accept=".png,.jpg,.jpeg,.svg" formControlName="Logo"
                        id="logoFile" (change)="handleFileInput1($event.target.files, attachmentTypes.clientLogo)" />
                      <label class="custom-file-label" for="logoFile">{{ getFile(attachmentTypes.clientLogo) || 'Choose
                        logo' }}</label>
                    </div>
                    <div *ngIf=" formData.get('Logo').touched || flag">
                      <mat-error class="errorFont" *ngIf="formData.get('Logo').errors?.required ">
                        Logo is Required</mat-error>
                    </div>
                  </div>


                </div>
              </div>
              <div class="col-12 p-0 mb-2">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">

                      <div><span class="secondaryInfo">Project Size</span></div>
                      <input class="form-control" min="0" (keypress)="numberOnly($event)"
                        [placeholder]="isView ? 0 : 'Enter Project Size'" formControlName="ProjectSize">
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Project Type</span></div>
                      <select class="form-control" formControlName="ProjectType">
                        <option value="" selected disabled hidden>Select</option>
                        <option *ngFor="let projectType of projectTypeOptions" [value]="projectType">{{projectType}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Delivery Model</span></div>
                      <select class="form-control" formControlName="DeliveryModel">
                        <option value="" selected disabled hidden>Select</option>
                        <option *ngFor="let deliveryModel of deliveryModelOptions" [value]="deliveryModel">
                          {{deliveryModel}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0 mb-4">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Sales Contact *</span></div>
                      <input type="text" class="form-control" (keyup)="Onchange()"
                        [placeholder]="isView ? '' :'Enter Sales Contact'" maxlength="40"
                        (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
                        [matAutocomplete]="partner" formControlName="BDContact">
                      <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
                        (optionSelected)='setCurrentEmployee($event.option.id)'>
                        <mat-option *ngFor="let partner of filteredValue" [id]="partner.employeeId"
                          [value]="partner.name">
                          {{partner.name}} ({{partner.employeeId}})
                        </mat-option>
                      </mat-autocomplete>
                      <div *ngIf="formData.get('BDContact').touched || flag">
                        <mat-error class="errorFont" *ngIf="formData.get('BDContact').errors?.required">
                          Sales Contact is Required</mat-error>
                        <mat-error class="errorFont" *ngIf="formData.get('BDContact').hasError('pattern')">
                          Invalid Format
                        </mat-error>

                      </div>

                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2"><span class="secondaryInfo">Content Type</span></div>
                    <select class="form-control" formControlName="ContentType">
                      <option *ngFor="let contentType of contentTypes" [value]="contentType">{{contentType}}</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div>
                        <span class="secondaryInfo">delivery Organization</span>
                      </div>
                      <select class="form-control" formControlName="DeliveryOrganization"
                        (change)="deliveryOrgChange()">
                        <option *ngFor="let deliveryOrganization of deliveryOrganizations"
                          [value]="deliveryOrganization.name">
                          {{deliveryOrganization.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0 mb-4">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div class="pr-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" formControlName="RestrictedContent" class="custom-control-input"
                          id="customCheck1">
                        <label class="custom-control-label w-100" for="customCheck1">Restricted Content</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-8 col-lg-8">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Tags(csv)</span></div>
                      <textarea rows="4" cols="50" class="form-control" formControlName="Tags"
                        [placeholder]="isView ? '' : 'Enter Tags'">

                      </textarea>
                    </div>
                  </div>
                  <div class="col-12 my-1"><span class="secondaryInfo">
                      {{ isView ? 'Presentations':'Select Presentation'}}</span></div>
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="pptLink" (click)="viewFile(projectDetails.fileURL)"
                      *ngIf="isView && projectDetails.fileURL != null; else showCaseStudyControl"> View Technology Case
                      Study </div>
                    <ng-template #showCaseStudyControl>
                      <div><span class="secondaryInfo">Technology Case Study</span></div>
                      <div class="custom-file pr-2">
                        <input type="file" formControlName="TCS" class="custom-file-input" id="caseStudy" accept=".pptx"
                          (change)="handleFileInput1($event.target.files , attachmentTypes.caseStudy)">

                        <label class="custom-file-label" for="logoFile">
                          {{getFile(attachmentTypes.caseStudy)}}</label>
                      </div>
                    </ng-template>
                    <div *ngIf="formData.get('TCS').touched || flag">
                      <mat-error class="errorFont" *ngIf="formData.get('TCS').errors?.required">
                        Technology Case Study is Required
                      </mat-error>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="pptLink" (click)="viewFile(projectDetails.bussinessCaseFileURL)"
                      *ngIf="isView && projectDetails.bussinessCaseFileURL != null; else showBussinessCaseStudyControl">
                      View Business Case Study
                      <span *ngIf="projectDetails.businessCaseStudyFlag">
                      </span>
                    </div>
                    <ng-template #showBussinessCaseStudyControl>
                      <div><span class="secondaryInfo">Business Case Study</span></div>
                      <div class="custom-file pr-2">
                        <input type="file" class="custom-file-input" id="bussinessCaseFileURL" accept=".pptx"
                          formControlName="BCS"
                          (change)="handleFileInput1($event.target.files , attachmentTypes.bussinessCaseStudy)">

                        <label class="custom-file-label" for="logoFile">
                          {{getFile(attachmentTypes.bussinessCaseStudy)}}
                        </label>
                      </div>
                    </ng-template>
                    <div *ngIf="formData.get('BCS').touched || flag">
                      <mat-error class="errorFont" *ngIf="formData.get('BCS').errors?.required">
                        Business Case Study is Required
                      </mat-error>
                    </div>
                  </div>
                  <div class="col-12 my-3" *ngIf="projectDetails && projectDetails.notes && permissions.canViewNotes">
                    <div class="list-group">
                      <a class="list-group-item list-group-item-action flex-column align-items-start headerColor">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="mb-1">Notes <span>({{projectDetails.notes.length}})</span></h5>
                        </div>
                      </a>
                      <a class="list-group-item list-group-item-action flex-column align-items-start"
                        *ngFor="let note of projectDetails.notes">
                        <div class="d-flex w-100 justify-content-between">
                          <h6 class="mb-1">{{note.createdBy}}</h6>
                          <small class="text-muted">{{note.duration}} ago</small>
                        </div>
                        <p class="mb-1">{{note.description}}</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex p-0 justify-content-center">
                <div class="buttons_column align-self-center  p-0" style="margin-left: auto;"
                  *ngIf="isPending || permissions.canUpdateProject;else showApproved">
                  <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-orange-app" id="inv_setup_save"
                    data-backdrop="static" data-keyboard="false" (click)="showCommentsDialog(true)">Approve</button>
                  <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-red" id="inv_setup_save"
                    data-backdrop="static" data-keyboard="false" (click)="showCommentsDialog(false)">Reject </button>
                  <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_save"
                    data-backdrop="static" data-keyboard="false" (click)="cancel()">Close
                  </button>
                </div>

                <ng-template #showApproved>
                  <div class="buttons_column p-0" style="margin-left: auto; margin-top: 1rem;">
                    <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-orange " *ngIf="!isView"
                      id="inv_setup_save" data-backdrop="static" data-keyboard="false" (click)="saveData()"
                      [disabled]="">Submit</button>

                    <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_cancel"
                      data-backdrop="static" data-keyboard="false" (click)="cancel()">{{isView ? 'Close': 'Cancel'}}
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <div class="overlay" (click)="dismissSidebar()"></div> -->